import { render } from "./AllClasses.vue?vue&type=template&id=c0b8b928&scoped=true"
import script from "./AllClasses.vue?vue&type=script&lang=js"
export * from "./AllClasses.vue?vue&type=script&lang=js"

import "./AllClasses.vue?vue&type=style&index=0&id=c0b8b928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b8b928"]])

export default __exports__